angular.module('common.filter.decimalNumberCalcResult', ['common.config', 'common.helper']).filter('decimalNumberCalcResult', function(CONSTANTS, CommonHelper){
    return function(number) {
        if (isNaN((number))){
            return null;
        }
        var newNumber = number;
        var numDecimals = CONSTANTS.numberFractionCalcResult;
        
        switch(CONSTANTS.roundingCalcResult) {
            case 'TRUNCATE':
                /* Truncate decimal value after set number of decimals */
                newNumber = CommonHelper.truncateDecimalNumber(newNumber, numDecimals);
                break;
            default:
                /* Round decimal value */
                break;
        }
        return accounting.formatNumber(newNumber, numDecimals, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
  };
});



// WEBPACK FOOTER //
// ./app/common/filter/decimal-number-calc-result-filter.js